import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoggerService} from '@app/service/logger/logger.service';
import {ResetPassword} from '@shared/state/auth/auth.actions';
import {Store} from '@ngxs/store';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Meta, Title} from '@angular/platform-browser';
import {setSEOInfo} from '@shared/helpers/seo';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', './../auth.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  errors: string[];
  messages: string[];
  user: any;
  submitted: boolean;
  loading = false;

  resetForm: FormGroup;

  constructor(private fb: FormBuilder, private title: Title, private meta: Meta, private ngZone: NgZone,
              public logger: LoggerService, private store: Store) {
    const pageName = 'Forgot Carvry Password';
    const desc = 'Update your password if you forgot it for Carvry';
    setSEOInfo(this.title, this.meta, pageName, desc);
  }

  ngOnInit() {
    this.messages = [];
    this.submitted = false;

    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  get f() {
    return this.resetForm.controls;
  }

  forgotPassword(): void {
    this.messages = [];
    this.submitted = true;

    // stop here if form is invalid
    if (this.resetForm.invalid) {
      return;
    }

    this.loading = true;
    const data = this.resetForm.value;
    this.store.dispatch(new ResetPassword({
      email: data.email
    }))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.loading = false;
        this.submitted = false;
      }, error => {
        this.logger.error(JSON.stringify(error.stack));
        this.loading = false;
        this.submitted = false;
      });
  }
}
